import styles from './ButtonTool.module.less';
import React from 'react';

interface ButtonToolI {
  icon: any;
  name?: string;
  isSelected: boolean;
  className?: string;
  onClick: () => void;
  responsive?: boolean;
}

function ButtonTool(props: ButtonToolI, ref: React.Ref<any>) {
  return (
    <div
      ref={ref}
      role="button"
      onClick={props.onClick}
      className={`${props.className || ''} h-full ${
        props.isSelected ? styles['button-tool--selected'] : ''
      } ${
        props.responsive ? styles['button-tool--mobile'] : ''
      } text-center cursor-pointer flex flex-wrap items-center justify-center ${
        props.responsive ? 'px-1 sm:px-0' : ''
      }`}
    >
      {typeof props.icon === 'string' && (
        <img
          className={`${
            props.responsive ? styles['button-tool__icon--mobile'] : styles['button-tool__icon']
          } w-full py-2`}
          src={props.icon}
          alt={props.name}
        />
      )}

      {typeof props.icon !== 'string' && (
        <props.icon
          className={`${
            props.responsive ? styles['button-tool__icon--mobile'] : styles['button-tool__icon']
          } w-full py-2`}
        />
      )}

      {props.name && (
        <div className={`${styles['button-tool__name']} w-full -mt-2 truncate text-center`}>
          {props.name}
        </div>
      )}
    </div>
  );
}

export default React.forwardRef(ButtonTool);
